function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Check to see if an object is a plain object (created using "{}" or "new Object").
 * @param {*} obj Variable of any type
 * @returns {Boolean}
 */
export var isPlainObject = function isPlainObject(obj) {
  return (// separate from primitives
    _typeof(obj) === "object" && // is obvious
    obj !== null && // separate instances (Array, DOM, ...)
    obj.constructor === Object && // separate build-in like Math
    Object.prototype.toString.call(obj) === "[object Object]"
  );
};